import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import widgetColoringBuilder from 'conversations-internal-schema/coloring/model/WidgetColoring';
import { getOptionLabel, getOptionValue
// @ts-expect-error dependency missing types
} from 'conversations-message-history/quick-reply/operators/quickReplyGetters';
// @ts-expect-error dependency missing types
import QuickReplyGroup from 'conversations-visitor-message-history/quick-reply/QuickReplyGroup';
// @ts-expect-error dependency missing types
import QuickReplySelect from 'conversations-visitor-message-history/quick-reply/QuickReplySelect';
import { Map as ImmutableMap, OrderedSet as ImmutableSet } from 'immutable';
import { useState } from 'react';
import styled from 'styled-components';
import VizExButton from 'visitor-ui-component-library/button/VizExButton';
import { createThemeV2 } from 'visitor-ui-component-library/theme/createThemeV2';
import { GREAT_WHITE, OBSIDIAN, OLAF } from 'HubStyleTokens/colors';
import { ChatWidgetLocaleContextConsumer } from '../ChatWidgetLocaleContext';
// @ts-expect-error untyped file
import ConsentPrompt from '../ConsentPrompt';
import { getCanReadTextOnce } from '../../util/textColorUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuickReplyGroupContainer = styled.div.withConfig({
  displayName: "QuickReplyGroupOutsideChat__QuickReplyGroupContainer",
  componentId: "sc-1kqw6xm-0"
})(["display:flex;flex-direction:column;gap:16px;"]);
const QuickReplyGroupWrapper = styled.div.withConfig({
  displayName: "QuickReplyGroupOutsideChat__QuickReplyGroupWrapper",
  componentId: "sc-1kqw6xm-1"
})(["display:flex;justify-content:", ";"], props => props.widgetLocation === 'RIGHT_ALIGNED' ? 'end' : 'start');
const QuickReplySelectContainer = styled.div.withConfig({
  displayName: "QuickReplyGroupOutsideChat__QuickReplySelectContainer",
  componentId: "sc-1kqw6xm-2"
})(["display:inline-flex;flex-direction:column;align-items:", ";width:240px;"], props => props.widgetLocation === 'RIGHT_ALIGNED' ? 'end' : 'start');
const QuickReplySelectSendButton = styled(VizExButton).withConfig({
  displayName: "QuickReplyGroupOutsideChat__QuickReplySelectSendButton",
  componentId: "sc-1kqw6xm-3"
})(["margin-top:8px;"]);
const ConsentPromptWrapper = styled.div.withConfig({
  displayName: "QuickReplyGroupOutsideChat__ConsentPromptWrapper",
  componentId: "sc-1kqw6xm-4"
})(["background:", ";color:", ";"], GREAT_WHITE, OBSIDIAN);
const noop = () => {};
const MAX_QUICK_REPLY_BUTTONS_OUTSIDE_CHAT = 4;
export const QuickReplyGroupOutsideChat = ({
  quickReplyOptions = ImmutableSet(),
  widgetLocation = 'RIGHT_ALIGNED',
  onQuickReplyOptionClick = noop,
  message,
  widgetColoring = widgetColoringBuilder(),
  publishMessage = noop,
  displayBotQuickRepliesOutsideChat = false,
  consentToProcessMessage,
  consentToProcess,
  showGdprConsentToProcessButton,
  closeConsentToProcess,
  showingGdprProcess = false,
  renderCookieConsentPrompt = false,
  consentToCookies,
  declineCookies,
  isPortal53 = false
}) => {
  const [selectedQuickReply, setSelectedQuickReply] = useState(ImmutableMap());
  const handleQuickReplyOptionClick = selectedQuickReplyOption => {
    const text = getOptionLabel(selectedQuickReplyOption);
    onQuickReplyOptionClick(text, selectedQuickReplyOption);
  };
  const handleQuickReplyOptionSelect = event => {
    const {
      target: {
        value
      }
    } = event;
    const newSelectedQuickReplyOption = quickReplyOptions.filter(option => getOptionValue(option) === value).first();
    setSelectedQuickReply(newSelectedQuickReplyOption);
  };
  const renderCookieConsentPromptComponent = () => {
    if (!renderCookieConsentPrompt) {
      return null;
    }
    return /*#__PURE__*/_jsx(ChatWidgetLocaleContextConsumer, {
      children: locale => /*#__PURE__*/_jsx(ConsentPromptWrapper, {
        widgetLocation: widgetLocation,
        children: /*#__PURE__*/_jsx(ConsentPrompt, {
          showButton: true,
          message: I18n.text('conversations-visitor-experience-components.gdpr.consentToCookies.pageLoadCookieConsent', {
            locale
          }),
          onClick: consentToCookies,
          onDeclineClick: declineCookies,
          coloring: widgetColoring,
          isPortal53: isPortal53,
          isOutsideChat: true
        })
      })
    });
  };
  const renderProcessDataConsentPromptComponent = () => {
    if (!showingGdprProcess || renderCookieConsentPrompt) {
      return null;
    }
    return /*#__PURE__*/_jsx(ConsentPromptWrapper, {
      widgetLocation: widgetLocation,
      children: /*#__PURE__*/_jsx(ConsentPrompt, {
        showButton: showGdprConsentToProcessButton,
        message: consentToProcessMessage,
        onClick: consentToProcess,
        onClose: closeConsentToProcess,
        coloring: widgetColoring,
        isPortal53: isPortal53,
        isOutsideChat: true
      })
    });
  };
  if (!displayBotQuickRepliesOutsideChat) {
    return null;
  }
  const isTextReadable = getCanReadTextOnce(widgetColoring.accentColor);
  const primaryColor = isTextReadable ? widgetColoring.accentColor : OBSIDIAN;
  const textColor = isTextReadable ? widgetColoring.textColor : OLAF;
  return /*#__PURE__*/_jsxs(QuickReplyGroupContainer, {
    children: [!renderCookieConsentPrompt && (!showingGdprProcess || !showGdprConsentToProcessButton) && /*#__PURE__*/_jsx(QuickReplyGroupWrapper, {
      widgetLocation: widgetLocation,
      children: quickReplyOptions.size <= MAX_QUICK_REPLY_BUTTONS_OUTSIDE_CHAT ? /*#__PURE__*/_jsx(QuickReplyGroup, {
        "data-test-id": 'quick-reply-group-outside-chat',
        disabled: false,
        options: quickReplyOptions,
        message: message,
        publishMessage: publishMessage,
        onSend: handleQuickReplyOptionClick,
        widgetLocation: widgetLocation,
        isOutsideChat: true,
        theme: createThemeV2({
          colors: {
            primary: primaryColor
          }
        })
      }) : /*#__PURE__*/_jsxs(QuickReplySelectContainer, {
        "data-test-id": 'quick-reply-select-container-outside-chat',
        widgetLocation: widgetLocation,
        children: [/*#__PURE__*/_jsx(QuickReplySelect, {
          disabled: false,
          quickReplyOptions: quickReplyOptions,
          onChange: handleQuickReplyOptionSelect,
          value: getOptionValue(selectedQuickReply),
          placeholder: I18n.text('conversations-visitor-experience-components.quickReply.selectionPlaceholder'),
          theme: createThemeV2({
            colors: {
              primary: primaryColor
            }
          })
        }), !selectedQuickReply.isEmpty() && /*#__PURE__*/_jsx(QuickReplySelectSendButton, {
          use: 'primary',
          onClick: () => handleQuickReplyOptionClick(selectedQuickReply),
          theme: createThemeV2({
            colors: {
              primary: primaryColor,
              textOnPrimary: textColor
            }
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-visitor-experience-components.quickReply.selectionComplete"
          })
        })]
      })
    }), renderCookieConsentPromptComponent(), renderProcessDataConsentPromptComponent()]
  });
};
QuickReplyGroupOutsideChat.displayName = 'QuickReplyGroupOutsideChat';
export default QuickReplyGroupOutsideChat;